import React, { useEffect } from 'react';
import { captureError } from '../../utilities/error';
import { useRedirect } from '../../hooks/useRedirect';
import Loading from '../../components/loading/Loading';
import useUrlParam from '../../mp/hooks/useUrlParam';
import { useOpenBookmarkQuery } from '../../redux/rtk';
var OpenBookmarkPage = function() {
    var redirect = useRedirect();
    var shareToken = useUrlParam('shareToken');
    var openBookmarkState = useOpenBookmarkQuery({
        shareToken: shareToken,
        redirectToRequestAccess: true
    }, {
        skip: !shareToken
    });
    useEffect(function() {
        var error = openBookmarkState.error;
        if (error) captureError(error);
    }, [
        openBookmarkState.error
    ]);
    useEffect(function() {
        var data = openBookmarkState.data;
        if (data && data.redirectUrl) {
            // redirect.push(data.redirectUrl);
            // Use window.location.href rathen redirect.push reload mp states especially for crdt
            // also avoid import worker script issue due to redirect.push
            window.location.href = data.redirectUrl;
        }
    }, [
        openBookmarkState.data,
        redirect
    ]);
    return /*#__PURE__*/ React.createElement(Loading, null);
};
export default OpenBookmarkPage;
